module.exports = __webpack_public_path__ + "static/Cross-functionalTeams-46e30101e981b21bc3a9d30c70112b05.jpg";